const PIXEL_ID = '1967293380558181'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function initMetaPixel(): void {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  window.fbq('init', PIXEL_ID)
}

export function trackPageView(): void {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(): void {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
